














import Vue from 'vue'
import { mapState } from 'vuex'
import Component from 'vue-class-component'
import JavascriptAPI from '@/utils/JavascriptAPI'

@Component({
  data: () => {
    return {
      message: null
    }
  },
  props: {
    translate: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: [String, Object],
      required: false
    },
    handleClose: {
      type: [Function],
      required: false
    },
    classes: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: false
    }
  }
})
export default class Notice extends Vue {
  message: any

  beforeMount () {
    const { text, translate } = this.$props
    if (this.$te(text)) {
      this.message = this.$t(text)
    } else {
      this.message = translate ? this.$t(text) : text
    }
  }

  mounted () {
    JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
  }

  get getWrapperClasses () {
    return `notice-container flex flex-center items-center ${this.$props.classes}`
  }
}
